import { inboundShipmentFileIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const deleteShipmentFile = {
  name: "deleteShipmentFile" as const,
  input: z.object({ fileId: inboundShipmentFileIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
